import React from 'react';
import ReactGA from 'react-ga';
import PropTypes from 'prop-types';
import Loader from 'react-loader';
import AuthStore from '../../stores/AuthStore.js';
import Auth from '../../utils/Auth';
import App from '../../utils/App.js';
import Header from './Header';
import Drawer from './Drawer';
import Content from './Content';
import SettingStore from '../../stores/SettingStore';
import { Settings } from '../../utils/Settings';

const Layout = React.createClass({

    getInitialState: function() {

        return {
            loaded: false,
            auth: new Auth({}),
            settings: new Settings([]),
            drawer: {
                open: false
            },
            gaInitialised: false
        };
    },

    getChildContext: function() {
        return {
            toggleLeftNav: this.toggleLeftNav,
            auth: this.state.auth,
            settings: this.state.settings,
        };
    },

    componentDidMount: function() {
        this.listeners = [
            AuthStore.addListener(this.onAuthChange),
            SettingStore.addListener(this.onSettingsChange)
        ];
        App.bootstrap();
    },

    componentWillUnmount: function() {
        this.listeners.forEach( listener => listener.remove() );
    },

    render: function() {

        let header, drawer, content, css;

        // if the user is not logged in or still fetching current user
        // we display empty elements
        if(false === this.state.auth.isLoggedIn()) {
            header  = <div />;
            drawer = <div />;
            content = <div />;
            css = '';
        } else {
            if (this.props.children === null) {
                header = <Header toggleLeftNav={this.toggleLeftNav} id="header"/>;
            }

            drawer  = <Drawer open={this.state.drawer.open} onRequestChange={this.toggleLeftNav} />;
            content = <Content children={this.props.children}/>;
            css = 'cent-layout';
        }
        try {
            return (
                <div ref="layout" className={css}>
                    {header}
                    {drawer}
                    {content}
                    {!this.state.loaded && (
                        <Loader loaded={false} />
                    )}
                </div>
            );
        } catch (e) {
            console.error(e);
        }
    },

    toggleLeftNav: function() {
        let state = this.state;
        state.drawer.open = !state.drawer.open;
        this.setState(state);
    },

    onAuthChange: function() {
        let userAuth = new Auth(AuthStore.getCurrentUser());
        this.setState({
            loaded: userAuth.isLoggedIn(),
            auth: userAuth,
            drawer: {
                open: false
            }
        });
    },

    onSettingsChange: function() {
        const settings = new Settings( SettingStore.getAll() );
        const changes = { settings };
        if (!this.state.gaInitialised) {
            const gaId = SettingStore.getValue('GOOGLE_ANALYTICS_ID');
            if (!!gaId) {
                ReactGA.initialize(gaId);
                this.props.history.listen(() => {
                    ReactGA.set({page: `${window.location.pathname}${window.location.search}`});
                    ReactGA.pageview(`${window.location.pathname}${window.location.search}`);
                });
                changes.gaInitialised = true;
            }
        }
        this.setState(changes);
    },

    goBack: function() {
        this.props.history.goBack();
    }


});

Layout.childContextTypes = {
    toggleLeftNav: PropTypes.func,
    auth: PropTypes.object,
    settings: PropTypes.object,
};

export default Layout;
